export const status_dictionary = {
	C: {
		displayText: 'En Catalogación',
		cssClass: 'bg-warning',
	},
	D: {
		displayText: 'Disponible',
		cssClass: 'bg-success',
	},
	E: {
		displayText: 'Encuadernacion',
		cssClass: 'bg-warning',
	},
	I: {
		displayText: 'Pedido',
		cssClass: 'bg-danger',
	},
	L: {
		displayText: 'En Línea',
		cssClass: 'bg-warning',
	},
	P: {
		displayText: 'Prestado',
		cssClass: 'bg-warning',
	},
	R: {
		displayText: 'Reservado',
		cssClass: 'bg-warning',
	},
	S: {
		displayText: 'Consulta en Sala',
		cssClass: 'bg-warning',
	},
	T: {
		displayText: 'Descarte',
		cssClass: 'bg-danger',
	},
	U: {
		displayText: 'Desubicado',
		cssClass: 'bg-danger',
	},
	X: {
		displayText: 'Extraviado',
		cssClass: 'bg-danger',
	},
};
